import React, { useState, useEffect } from 'react';
import { get } from 'lodash/fp';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Loader, Content } from 'rsuite';
import PageHeader from '../../../../../components/PageHeader';
import PageLayout from '../../../../../components/Reports/PageLayout';
import OutreachAggregateView from '../../../../../containers/OutreachAggregateView';
import AccessControl from '../../../../../components/AccessControl';
import AccessDenied from '../../../../../components/AccessDenied';
import { viewAccess } from '../../../../../helpers/permission';
import * as PERMISSIONS from '../../../../../constants/permissions';
import {
  fetchDownloadRequest,
  fetchDownloadRequestResult
} from '../../../../../redux/sagas/routines';
import {
  getIsFetching,
  getIsFetchingResult,
  getDownloadRequestForId,
  getDownloadRequestResultForId
} from '../../../../../redux/selectors/download-request';
import { Status } from '../../../../../constants/download-request';

function OutreachAggregateReport() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [isRefetch, setIsRefetch] = useState(false);
  const isFetchingDownloadRequest = useSelector(getIsFetching);
  const isFetchingResult = useSelector(getIsFetchingResult);
  const downloadRequest = useSelector(state =>
    getDownloadRequestForId(state, id)
  );
  const result = useSelector(state => getDownloadRequestResultForId(state, id));
  const isInProgress = get('status', downloadRequest) === Status.IN_PROGRESS;
  const isDataLoaded = !isFetchingDownloadRequest && !isFetchingResult;

  useEffect(
    () => {
      dispatch(fetchDownloadRequest(id));
      dispatch(fetchDownloadRequestResult(id));
    },
    [id]
  );

  useEffect(
    () => {
      const interval = setInterval(() => {
        if (isDataLoaded && isInProgress) {
          setIsRefetch(true);
          dispatch(fetchDownloadRequest(id));
          dispatch(fetchDownloadRequestResult(id));
        } else {
          clearInterval(interval);
        }
      }, 5000);
      return () => clearInterval(interval);
    },
    [isInProgress, isDataLoaded]
  );

  return (
    <PageLayout>
      <AccessControl
        allowOnlyFor={viewAccess(PERMISSIONS.OUTREACH_AGG_REPORT)}
        fallback={<AccessDenied />}
      >
        <PageHeader title="Report View" />
        <Content style={{ marginTop: 0 }}>
          {!isDataLoaded && !isRefetch ? (
            <Loader center />
          ) : (
            <OutreachAggregateView
              downloadRequest={downloadRequest}
              result={result}
            />
          )}
        </Content>
      </AccessControl>
    </PageLayout>
  );
}

export default OutreachAggregateReport;
